
import { useState, useEffect } from 'react';
import { Button } from '../base/Button';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-navy-900 border-b border-cyan-400/20 shadow-lg shadow-cyan-400/10' 
        : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/38c4b7aa-285c-49b4-a4e2-25a3feb3886d.png" 
              alt="DUVANKA DOO Logo" 
              className="w-8 h-8 object-contain mr-3"
            />
            <h1 className="text-white font-bold text-xl tracking-wide">DUVANKA DOO</h1>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            {['home', 'vpn', 'features', 'about', 'contact', 'faq'].map((section) => (
              <button
                key={section}
                onClick={() => scrollToSection(section)}
                className="text-gray-300 hover:text-cyan-400 transition-all duration-300 capitalize font-medium hover:underline decoration-cyan-400 underline-offset-4 cursor-pointer"
              >
                {section}
              </button>
            ))}
          </div>

          <Button 
            onClick={() => scrollToSection('contact')}
            size="sm"
          >
            Get Started
          </Button>
        </div>
      </div>
    </nav>
  );
};
